import ReactMarkdown from 'react-markdown'
import breaks from 'remark-breaks'

import styles from './FuseHighlight.module.sass'

const highlight = (value, indices = [], i = 1) => {
	const pair = indices[indices.length - i]
	return !pair
		? value
		: `${highlight(
				value.substring(0, pair[0]),
				indices,
				i + 1
		  )}*${value.substring(pair[0], pair[1] + 1)}*${value.substring(
				pair[1] + 1
		  )}`
}

const FuseHighlight = ({ text, matchedWords }) => {
	const result = highlight(text, matchedWords)

	return (
		<ReactMarkdown
			plugins={[breaks]}
			allowedTypes={[
				'break',
				'paragraph',
				'strong',
				'text',
				'list',
				'listItem',
				'code',
				'emphasis',
				'heading',
			]}
			unwrapDisallowed={true}
			renderers={{
				emphasis: ({ children }) => (
					<mark className={styles['highlight']}>{children}</mark>
				),
				paragraph: ({ children }) => children,
				heading: ({ children }) => {
					return <p># {children}</p>
				},
				break: () => {
					return '\n'
				},
			}}
			source={result}
		/>
	)
}

export default FuseHighlight
